import { render, staticRenderFns } from "./service_details.vue?vue&type=template&id=7ce685dc&scoped=true&"
import script from "./service_details.vue?vue&type=script&lang=js&"
export * from "./service_details.vue?vue&type=script&lang=js&"
import style0 from "./service_details.vue?vue&type=style&index=0&id=7ce685dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce685dc",
  null
  
)

export default component.exports